const MenuId = {
  CHANNELS: 'channels',
  RADIO: 'radio',
  YOUTUBE: 'youtube',
  CAST: 'cast',
  TIME: 'time',
  WEATHER: 'weather',
  PORTAL: 'portal',
  NEWS: 'news',
  INTERNET: 'internet',
  SETTINGS: 'settings',
};

export default MenuId;
